import { useAccessibleContext } from '#hooks/UNSAFE_useAccessibleContext';
import { classNames as mergeIds } from '#utils/UNSAFE_classNames';

type UseLabelledLinkAriaProps = {
  'aria-describedby'?: string;
  baseId: string;
  hasEmptyLabel: boolean;
  hasHiddenLabel: boolean;
  labelId?: string;
};

export function useLabelledLinkAria({
  'aria-describedby': ariaDescribedBy,
  baseId,
  hasEmptyLabel,
  hasHiddenLabel,
  labelId: propLabelId
}: UseLabelledLinkAriaProps) {
  const containerId = `${baseId}--container`;
  const labelId = propLabelId ?? `${baseId}--hidden-label`;

  // JET-52089: add unsafe API for specifying an external label which is added to ariaLabelledBy on the input or div,
  // only when labelEdge is 'none' and label is ''. Since ariaLabelledBy takes precedence over all other
  // kinds of labels, this helps to ensure we don't override a meaningful label.
  const { UNSAFE_ariaLabelledBy } = useAccessibleContext();
  const ariaLabelledBy = mergeIds([
    labelId,
    hasEmptyLabel && hasHiddenLabel && UNSAFE_ariaLabelledBy,
    containerId
  ]);

  return {
    containerAria: {
      id: containerId
    },
    hiddenLabelAria: hasHiddenLabel
      ? {
          id: labelId
        }
      : {},
    linkAria: {
      'aria-describedby': ariaDescribedBy,
      'aria-labelledby': ariaLabelledBy
    }
  };
}
